export default {
   getFPlusReportData(orderId, token = 0) {
      return token ? this.getFraudReportIntegrationData(orderId) : this.getFraudplusFinalReport(orderId)
   },
   saveFPlusStatus(Obj, token = 0) {
    return token ? this.saveFraudReportIntegrationStatus(Obj) : this.saveStatus(Obj)
   },
   saveFPlusRemarks(Obj, token = 0) {
    return token ? this.saveFraudReportIntegrationRemarks(Obj) : this.saveRemarks(Obj)
   },
   // ARS table sorting
   getARSSortedData(Obj, token = 0) {
      return token ? this.fetchARSIntegrationSortData(Obj) : this.fetchARSFraudXSortData(Obj)
   },
   // Get PDF report generated from API
   getFraudXPDFReport(payload, token = 0) {
      return token ? this.fetchFraudXIntegrationPDF(payload) : this.fetchFraudXPDF(payload)
   },
  }
